import { string, object, boolean } from 'yup';

const eventSchema = object().shape({
  name: string().required('The field Name is required'),
  date: string().required('The field Date is required'),
  description: string().required('The field Description is required'),
  isPaid: boolean(),
});

export default eventSchema;
